;(function(w){
	function MenuBtn(element){
		
		var route_key = $(element).data('route-key');

		var active = false;
		var visited = false;


		this.setActive = function(valor){
			active = valor;
			
			if(active){
				if(!visited){
					visited = true;
					$(element).addClass('visited');	
				}
				
				$(element).addClass('active');
			}else{
				$(element).removeClass('active');
			}
		}

		this.setVisited = function(){
			$(element).addClass('visited');
		}

		this.getRouteKey = function(){
			return route_key;
		}

	}
	
	w.MenuBtn = MenuBtn;
})(window)